var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text !== null)?_c('p',{staticClass:"color--red text__error mb-0",style:(_vm.styleObj)},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }